import { styled } from '@mui/material/styles'
import AvatarGroup, { AvatarGroupProps } from '@mui/material/AvatarGroup'

export interface IAvatarGroup extends AvatarGroupProps {
  size?: 'xsmall' | 'small' | 'medium' | 'large'
  bordercolor?: 'light' | 'dark'
}

export const ThemedAvatarGroup = styled(AvatarGroup)<IAvatarGroup>(
  ({ theme, size, bordercolor = 'light' }) => ({
    width: 'fit-content',
    marginLeft: '1.6rem',
    '.MuiAvatarGroup-avatar': {
      width: '4.0rem',
      height: '4.0rem',
      backgroundColor: theme.palette.primary[500],
      fontWeight: 'bold',
      border: '2px solid',
      ...(bordercolor === 'light' && {
        borderColor: theme.palette.common.white,
      }),
      ...(bordercolor === 'dark' && {
        borderColor: theme.palette.primary[600],
      }),
      ...(size === 'xsmall' && {
        width: '2.5rem',
        height: '2.5rem',
        fontSize: '1.4rem',
      }),
      ...(size === 'small' && {
        width: '3.2rem',
        height: '3.2rem',
        fontSize: '1.8rem',
      }),
      ...(size === 'medium' && {
        width: '4.0rem',
        height: '4.0rem',
        fontSize: '1.8rem',
      }),
      ...(size === 'large' && {
        width: '8.6rem',
        height: '8.6rem',
        fontSize: '2.8rem',
      }),
    },
  })
)
